import React, { useEffect, useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { Col, Row } from 'react-bootstrap'
import { accountsSelector } from '../../../selectors'
import { useSelector } from 'react-redux'

import PaymentsService from '../../../services/payments.service'
import MenuCard from '../../../layout/Navigation/menu-card'
import DynamicMenuCard from '../../../layout/Navigation/DynamicCard'

export default function QuickPayServicesView() {
  const history = useHistory()
  const location = useLocation()
  const accounts = useSelector(accountsSelector) || []
  const [billerList, setBillerList] = useState([])
  const [data, setData] = useState({})

  useEffect(() => {
    location.pathname.includes('/beneficiary-transfers') && setData({url:'/beneficiary-transfers', breadCrumb:'TRANSFERS_QUICK_PAY_SERVICES_VIEW'})
    location.pathname.includes('/accounts') && setData({url:'/accounts', breadCrumb:'ACCOUNTS_QUICK_PAY_SERVICES_VIEW'})
    if (location?.state === undefined || location?.state === null) {
      history.push(`${data.url}/quick-pay`)
      return
    }
    getBillProducts()
  }, [])

  const getBillProducts = useCallback(async () => {
    try {
      const { categoryDetails } = location.state
      const response = await PaymentsService.getAllBillers({
        fetchServices: true,
        fetchProducts: true,
        module: 'TRANSFER',
      })
      if (response.status === 200) {
        let serviceDetails = response.data['categories'].filter(
          (ele) => ele.category === categoryDetails.category,
        )[0].services
        // console.log(serviceDetails)
        serviceDetails.forEach((element) => {
          element.title = element.description
          element.icon = element.logo
          element.key = element.serviceId
        })
        setBillerList(serviceDetails)
      }
    } catch (err) {
      console.log(err)
    }
  }, [])

  return (
    <LayoutWithAccountCard breadCumKey={data.breadCrumb}>
      <Row>
        {billerList.map((option, index) => (
          <DynamicMenuCard
            handleMenuCallback={() =>
              history.push({
                pathname: `${data.url}/quick-pay/services/product`,
                state: { serviceDetails: option },
              })
            }
            icon={option.icon}
            name={option.title}
            description={option.description}
            key={index}
          />
        ))}
      </Row>
    </LayoutWithAccountCard>
  )
}
